/* eslint-disable */ /**
  OBSOLETE - use google tag manager service instead:
  src\EbaySweden.TouchWeb\static\script\app\ui\google-tagmanager-service.js


 * Ported from Applications/TouchWeb/src/EbaySweden.TouchWeb/static/script/app/ui/layout/google-tagmanager.js
 * Best way to import this module is `import * as Analytics from 'analytics'`
 */

import * as Sentry from '@sentry/browser';

export const pushToDataLayer = payload => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
};
export const trackPageView = () =>
    window.ga
        ? ga('send', 'pageview', location.pathname)
        : pushToDataLayer({ event: 'trackPageview' });
export const isNonInteractive = analyticsData =>
    analyticsData.userTriggered === undefined
        ? true
        : !analyticsData.userTriggered;
/**
 * trackTiming
 * @param {*} category
 * @param {*} variable
 * @param {*} value
 * @param {*} label
 */
export const trackTiming = (category, variable, value, label = '') =>
    window.ga ? ga('send', 'timing', category, variable, value, label) : false;

/**
 * Track Analytics Event
 */
export const trackEvent = analyticsData => {
    if (!analyticsData) {
        return;
    }
    pushToDataLayer({
        event: 'trackEvent',
        eventCategory: analyticsData.category || '',
        eventAction: analyticsData.action || '',
        eventLabel: analyticsData.label || '',
        eventValue: analyticsData.value || '0',
        eventNonInteractive: isNonInteractive(analyticsData),
        hitCallback: analyticsData.hitCallback || []
    });

    Sentry.addBreadcrumb({
        type: 'default',
        level: Sentry.Severity.Info,
        category: isNonInteractive(analyticsData) ? 'tracking' : 'ui-action',
        message: 'Analytics Event',
        data: analyticsData
    });
};

// Export object for Sinon stubbing
export default {
    pushToDataLayer,
    trackEvent,
    trackPageView,
    trackTiming
};
